import { FilterOperatorEnum } from '@/types/schema';

export enum OperatorSelectVariant {
  AnyAll = 'ANY_ALL',
  AndOr = 'AND_OR',
}

export interface OperatorSelectProps {
  variant?: OperatorSelectVariant;
  selectedValue: FilterOperatorEnum;
  onChange: (val: FilterOperatorEnum) => void;
  className?: string;
  disabled?: boolean;
}
